import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export const StudentAddressService = {
  create,  
  getUserAddressesByUserId
};

async function create(addressList) {
  const requestOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: addressList,
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/registration/user-addresses/add`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}

async function getUserAddressesByUserId(id) {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/registration/user-addresses/user/${id}`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}
